module.exports = [{
      plugin: require('/Users/ohinako/Documents/GitHub/picks_lp/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-115890400-1"],"pluginConfig":{"head":true}},
    },{
      plugin: require('/Users/ohinako/Documents/GitHub/picks_lp/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
